import { useEffect, useRef, useState } from 'react';

export function useChatCopy(kind: 'code' | 'table', resetMs: number) {
  const [copied, setCopied] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout>>(undefined);

  useEffect(() => () => clearTimeout(timer.current), []);

  async function copy(text: string) {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      clearTimeout(timer.current);
      timer.current = setTimeout(() => setCopied(false), resetMs);
    } catch (error: unknown) {
      console.warn(`Could not copy ${kind} to clipboard`, error);
    }
  }

  return { copied, copy };
}
